import DOMPurify from 'dompurify';
function Heading(props) {
  let classNames = `${props.className} tw-text-center tw-max-w-screen-lg tw-m-auto tw-px-6`;
  let headlineClassNames = props.headlineClassNames;
  let headerStyle ={wordBreak:'keep-all'};
  return (
    <div className={classNames}>
      { props.title && (<h2 style={headerStyle} className={"tw-tracking-tight tw-text-teal tw-font-italic tw-text-3xl tw-uppercase tw-leading-6 md:tw-leading-3 tw-mt-4 "+headlineClassNames} >{props.title}</h2>)}
      {props.subtitle && (
        <p style={headerStyle} className="tw-font-text tw-text-md tw-leading-5 tw-my-6" 
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.subtitle) }}/>
      )}
    </div>
  );
}

export default Heading;
